export default __webpack_public_path__ + "static/media/ai-avatar.0344016a.svg";